/*
  DISCOVURY — Theme JavaScript
  Cart Drawer · Mobile Menu · Accordion · Sticky Header · Add to Cart
*/

document.addEventListener('DOMContentLoaded', function () {

  // ─── Cart Drawer ────────────────────────────────────────────────────
  const cartOverlay = document.getElementById('cart-overlay');
  const cartDrawer  = document.getElementById('cart-drawer');
  const cartOpenBtns = document.querySelectorAll('[data-cart-open]');
  const cartCloseBtn = document.getElementById('cart-close');

  function openCart() {
    cartOverlay && cartOverlay.classList.add('active');
    cartDrawer  && cartDrawer.classList.add('open');
    document.body.style.overflow = 'hidden';
  }

  function closeCart() {
    cartOverlay && cartOverlay.classList.remove('active');
    cartDrawer  && cartDrawer.classList.remove('open');
    document.body.style.overflow = '';
  }

  cartOpenBtns.forEach(btn => btn.addEventListener('click', openCart));
  cartCloseBtn && cartCloseBtn.addEventListener('click', closeCart);
  cartOverlay  && cartOverlay.addEventListener('click', closeCart);

  // ─── Add to Cart ─────────────────────────────────────────────────────
  document.querySelectorAll('[data-add-to-cart]').forEach(btn => {
    btn.addEventListener('click', async function (e) {
      e.preventDefault();
      const variantId = this.dataset.variantId;
      if (!variantId || this.disabled) return;

      const originalText = this.textContent;
      this.textContent = 'Adding...';
      this.disabled = true;

      const resetButton = (newText, holdMs) => {
        if (newText) this.textContent = newText;
        setTimeout(() => {
          this.textContent = originalText;
          this.disabled = false;
        }, holdMs || 1500);
      };

      try {
        const res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ id: variantId, quantity: 1 }),
        });

        if (res.ok) {
          await refreshCart();
          openCart();
          if (window.dscAnnounce) window.dscAnnounce('Added to cart');
          resetButton('Added!', 1500);
        } else {
          // Shopify returns 422 with { description: "..." } on stock/variant errors
          let message = 'Could not add to cart';
          try {
            const body = await res.json();
            if (body && body.description) message = body.description;
          } catch (_) { /* non-JSON response */ }
          if (window.dscAnnounce) window.dscAnnounce(message);
          resetButton('Unavailable', 2000);
        }
      } catch (err) {
        console.error('Add to cart error:', err);
        if (window.dscAnnounce) window.dscAnnounce('Network error. Please try again.');
        resetButton('Try again', 2000);
      }
    });
  });

  // ─── Refresh Cart ─────────────────────────────────────────────────────
  async function refreshCart() {
    try {
      const res  = await fetch('/cart.js');
      const cart = await res.json();

      // Update count badge (cap display at 99+)
      document.querySelectorAll('[data-cart-count]').forEach(el => {
        el.textContent = cart.item_count > 99 ? '99+' : cart.item_count;
        el.style.display = cart.item_count > 0 ? 'flex' : 'none';
      });

      // Update subtotal
      const subtotalEl = document.getElementById('cart-subtotal');
      if (subtotalEl) {
        subtotalEl.textContent = formatMoney(cart.total_price);
      }

      // Render cart items
      const itemsEl = document.getElementById('cart-items-list');
      if (itemsEl) {
        if (cart.items.length === 0) {
          itemsEl.innerHTML = `
            <div class="cart-empty">
              <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1" stroke-linecap="round" stroke-linejoin="round">
                <path d="M6 2 3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z"/><line x1="3" y1="6" x2="21" y2="6"/><path d="M16 10a4 4 0 0 1-8 0"/>
              </svg>
              <p>Your cart is empty</p>
            </div>`;
        } else {
          itemsEl.innerHTML = cart.items.map(item => {
            const imgSrc = item.image
              ? item.image.replace(/(\.[^.\/]+)$/, '_200x$1')
              : '';
            const imgMarkup = imgSrc
              ? `<img src="${escapeAttr(imgSrc)}" alt="${escapeAttr(item.title)}" loading="lazy" width="72" height="72">`
              : '';
            return `
            <div class="cart-item">
              <div class="cart-item-img">${imgMarkup}</div>
              <div style="flex:1;min-width:0;">
                <p class="cart-item-name">${escapeHtml(item.product_title)}</p>
                <p class="cart-item-price">${formatMoney(item.line_price)}</p>
                <div class="qty-controls">
                  <button class="qty-btn" data-change="-1" data-key="${escapeAttr(item.key)}" aria-label="Decrease quantity">−</button>
                  <span class="qty-val" aria-live="polite">${item.quantity}</span>
                  <button class="qty-btn" data-change="1" data-key="${escapeAttr(item.key)}" aria-label="Increase quantity">+</button>
                  <button class="cart-item-remove" data-remove="${escapeAttr(item.key)}" aria-label="Remove ${escapeAttr(item.product_title)}">Remove</button>
                </div>
              </div>
            </div>`;
          }).join('');

          // Bind qty change + remove
          itemsEl.querySelectorAll('[data-change]').forEach(btn => {
            btn.addEventListener('click', async function () {
              if (this.disabled) return;
              const key   = this.dataset.key;
              const delta = parseInt(this.dataset.change, 10);
              const qtyEl = this.parentElement.querySelector('.qty-val');
              const newQty = Math.max(0, parseInt(qtyEl.textContent, 10) + delta);
              // Disable both qty buttons in this row while updating
              const siblings = this.parentElement.querySelectorAll('.qty-btn, [data-remove]');
              siblings.forEach(b => b.disabled = true);
              await updateCartItem(key, newQty);
              // refreshCart re-renders, so we don't need to re-enable
            });
          });

          itemsEl.querySelectorAll('[data-remove]').forEach(btn => {
            btn.addEventListener('click', async function () {
              if (this.disabled) return;
              this.disabled = true;
              await updateCartItem(this.dataset.remove, 0);
            });
          });
        }
      }

      // Free shipping bar
      const freeShipEl = document.getElementById('free-shipping-bar');
      if (freeShipEl) {
        const remaining = 5000 - cart.total_price; // $50 threshold in cents
        if (remaining > 0) {
          freeShipEl.style.display = 'block';
          freeShipEl.textContent = `Add ${formatMoney(remaining)} more for free shipping`;
        } else {
          freeShipEl.style.display = 'none';
        }
      }

    } catch (err) {
      console.error('Cart refresh error:', err);
    }
  }

  // Serialize cart mutations so rapid +/- clicks can't race
  let cartUpdateChain = Promise.resolve();
  function updateCartItem(key, qty) {
    cartUpdateChain = cartUpdateChain.then(async () => {
      try {
        const res = await fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ id: key, quantity: qty }),
        });
        if (!res.ok) {
          let message = 'Could not update cart';
          try {
            const body = await res.json();
            if (body && body.description) message = body.description;
          } catch (_) { /* non-JSON response */ }
          if (window.dscAnnounce) window.dscAnnounce(message);
        } else if (qty === 0 && window.dscAnnounce) {
          window.dscAnnounce('Item removed from cart');
        }
      } catch (err) {
        console.error('Cart update error:', err);
        if (window.dscAnnounce) window.dscAnnounce('Network error. Please try again.');
      } finally {
        await refreshCart();
      }
    });
    return cartUpdateChain;
  }

  function escapeHtml(str) {
    return String(str == null ? '' : str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;');
  }
  function escapeAttr(str) {
    return escapeHtml(str).replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }

  function formatMoney(cents) {
    const format = (window.theme && window.theme.moneyFormat) || '${{amount}}';
    const amount = (cents / 100).toFixed(2);
    const amountNoDecimals = Math.round(cents / 100).toString();
    const amountWithComma = amount.replace('.', ',');
    const amountNoDecimalsWithComma = amountNoDecimals;
    return format
      .replace(/\{\{\s*amount\s*\}\}/g, amount)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, amountNoDecimals)
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, amountWithComma)
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g, amountNoDecimalsWithComma);
  }

  // Initial cart load
  refreshCart();

  // ─── Mobile Menu ──────────────────────────────────────────────────────
  const mobileMenuBtn  = document.getElementById('mobile-menu-btn');
  const mobileMenu     = document.getElementById('mobile-menu');

  mobileMenuBtn && mobileMenuBtn.addEventListener('click', function () {
    const isOpen = mobileMenu.style.display === 'block';
    mobileMenu.style.display = isOpen ? 'none' : 'block';
    this.setAttribute('aria-expanded', !isOpen);
  });

  // Close mobile menu on link click
  mobileMenu && mobileMenu.querySelectorAll('a').forEach(a => {
    a.addEventListener('click', () => {
      mobileMenu.style.display = 'none';
    });
  });

  // ─── Accordion ────────────────────────────────────────────────────────
  document.querySelectorAll('.accordion-btn').forEach(btn => {
    btn.setAttribute('aria-expanded', 'false');
    btn.addEventListener('click', function () {
      const content = this.nextElementSibling;
      const isOpen  = content.classList.contains('open');

      // Close all
      document.querySelectorAll('.accordion-content').forEach(c => c.classList.remove('open'));
      document.querySelectorAll('.accordion-btn').forEach(b => {
        b.setAttribute('aria-expanded', 'false');
        const i = b.querySelector('.accordion-icon');
        if (i) i.textContent = '+';
      });

      if (!isOpen) {
        content.classList.add('open');
        this.setAttribute('aria-expanded', 'true');
        const icon = this.querySelector('.accordion-icon');
        if (icon) icon.textContent = '−';
      }
    });
  });

  // ─── Product Gallery Thumbnails ───────────────────────────────────────
  document.querySelectorAll('.product-thumb').forEach(thumb => {
    thumb.addEventListener('click', function () {
      const src = this.dataset.src;
      const mainImg = document.querySelector('.product-main-img img');
      if (mainImg && src) {
        mainImg.src = src;
        document.querySelectorAll('.product-thumb').forEach(t => t.classList.remove('active'));
        this.classList.add('active');
      }
    });
  });

  // ─── Email Form ───────────────────────────────────────────────────────
  // The email-capture form is a Shopify {% form 'customer' %} that posts to
  // /contact?form_type=customer. Native submit handles the real subscription
  // (Shopify shows success/error via redirect). We only validate client-side
  // and let the form submit. Older versions of this theme faked a success
  // state without ever calling Shopify; that behaviour is removed.
  const emailForm = document.getElementById('email-capture-form');
  if (emailForm) {
    emailForm.addEventListener('submit', function (e) {
      const input = this.querySelector('input[type="email"]');
      const email = input && input.value.trim();
      const validShape = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
      if (!email || !validShape) {
        e.preventDefault();
        input && input.focus();
        if (window.dscAnnounce) window.dscAnnounce('Please enter a valid email address.');
      }
      // Otherwise let Shopify handle the submission natively.
    });
  }

  // ─── Variant Selection ────────────────────────────────────────────────
  document.querySelectorAll('.variant-options').forEach(group => {
    group.setAttribute('role', 'radiogroup');
    group.querySelectorAll('.variant-btn').forEach(btn => {
      btn.setAttribute('role', 'radio');
      btn.setAttribute('aria-checked', btn.classList.contains('active') ? 'true' : 'false');
    });
  });

  document.querySelectorAll('.variant-btn').forEach(btn => {
    btn.addEventListener('click', function () {
      const group = this.closest('.variant-options');
      group.querySelectorAll('.variant-btn').forEach(b => {
        b.classList.remove('active');
        b.setAttribute('aria-checked', 'false');
      });
      this.classList.add('active');
      this.setAttribute('aria-checked', 'true');

      // Update hidden variant ID for add-to-cart
      const addBtn = document.querySelector('[data-add-to-cart]');
      if (addBtn && this.dataset.variantId) {
        addBtn.dataset.variantId = this.dataset.variantId;
      }
    });
  });

  // ─── Screen-reader announcement region ────────────────────────────────
  let liveRegion = document.getElementById('sr-live-region');
  if (!liveRegion) {
    liveRegion = document.createElement('div');
    liveRegion.id = 'sr-live-region';
    liveRegion.setAttribute('aria-live', 'polite');
    liveRegion.setAttribute('aria-atomic', 'true');
    liveRegion.className = 'visually-hidden';
    document.body.appendChild(liveRegion);
  }
  window.dscAnnounce = function (message) {
    liveRegion.textContent = '';
    // Defer so the same message can be re-announced
    setTimeout(() => { liveRegion.textContent = message; }, 50);
  };

  // ─── Motion: scroll reveals, cart pulse, scrolled header ──────────────
  document.body.classList.add('js-ready');

  const prefersReducedMotion = window.matchMedia &&
    window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  const REVEAL_SELECTORS = [
    '.benefits-section .benefit-item',
    '.product-feature .feature-img-wrap',
    '.product-feature .feature-copy > *',
    '.ingredients-section .ingredients-header > *',
    '.ingredients-section .ingredient-row',
    '.testimonials-section .testimonial-card',
    '.testimonials-section .trust-bar > *',
    '.product-grid-section .product-card',
    '.product-grid-section .section-header > *',
    '.email-section .email-inner > *',
    '.fcta-inner > *',
    '.fp-inner > *',
    '.dsc-about__hero > *',
    '.dsc-about__mission > *',
    '.dsc-about__values-grid > *',
    '.dsc-about__manifesto > *',
    '.dsc-about__commit-grid > *',
    '.dsc-contact__grid > *',
    '.faq-question',
    '.lookbook-inner > *',
    '.product-tabs-inner > *'
  ];

  if ('IntersectionObserver' in window && !prefersReducedMotion) {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-revealed');
          observer.unobserve(entry.target);
        }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.05 });

    document.querySelectorAll(REVEAL_SELECTORS.join(',')).forEach((el) => {
      el.setAttribute('data-reveal', '');
      observer.observe(el);
    });
  } else {
    // No IO or reduced motion: ensure elements are visible immediately
    document.querySelectorAll(REVEAL_SELECTORS.join(',')).forEach((el) => {
      el.classList.add('is-revealed');
    });
  }

  // Cart count badge pulses when the number changes
  const cartCountEls = document.querySelectorAll('[data-cart-count]');
  cartCountEls.forEach((el) => {
    let prev = parseInt(el.textContent, 10) || 0;
    const mo = new MutationObserver(() => {
      const next = parseInt(el.textContent, 10) || 0;
      if (next !== prev && next > 0 && !prefersReducedMotion) {
        el.classList.remove('is-pulsing');
        void el.offsetWidth; // restart animation
        el.classList.add('is-pulsing');
      }
      prev = next;
    });
    mo.observe(el, { characterData: true, childList: true, subtree: true });
  });

  // Sticky header shadow once user scrolls past hero edge
  const header = document.querySelector('.site-header');
  if (header) {
    let ticking = false;
    const onScroll = () => {
      if (!ticking) {
        requestAnimationFrame(() => {
          header.classList.toggle('is-scrolled', window.scrollY > 24);
          ticking = false;
        });
        ticking = true;
      }
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

});
